import React, { ReactElement } from "react";
import styled from "styled-components";
import { TimeSlotSelectorProps } from "../.";
import { VenueTimeSlotSelectorStyles } from "../../types/styles";
import VenueInfo from "../VenueInfo/VenueInfo";

export type VenueTimeslotSelectorProps = {
  providerName: string;
  providerLocation: string;
  providerLocationUrl: string;
  children: ReactElement<TimeSlotSelectorProps>;
  styles: VenueTimeSlotSelectorStyles;
};

const Container = styled.div<{
  styles: VenueTimeSlotSelectorStyles;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${({ styles }) => styles.OverallGeneralTextColour};
`;

export const VenueTimeslotSelector: React.FC<VenueTimeslotSelectorProps> = ({
  providerName,
  providerLocation,
  providerLocationUrl,
  children,
  styles,
}) => {
  return (
    <Container styles={styles}>
      <VenueInfo
        providerName={providerName}
        providerLocation={providerLocation}
        providerLocationUrl={providerLocationUrl}
        styles={styles}
      />
      {children}
    </Container>
  );
};

export default VenueTimeslotSelector;
